import type { DynamicCalculationId, DynamicCalculationIdEvents } from '../types/dynamicMetrics';
import { DATA_FIELD_KEY_SEPARATOR, DYNAMIC_CALCULATION_DATA_FIELD_KEY_PREFIX, EVENT_DATA_FIELD_KEYS } from './dataFieldKeys';
import type { DynamicCalculationDataFieldKey } from '../types';
import { COST, REVENUE, ROAS } from './druidMetrics';

export const DEFAULT_COLUMN_GROUP_PROPS = {
  alwaysEnabled: false,
  selected: false,
  type: 'metric' as const,
};

export const CALCULATION_ID_EVENTS: DynamicCalculationIdEvents = {
  installs_per: {
    eventName: EVENT_DATA_FIELD_KEYS.INSTALL,
    label: 'installs per',
  },
  cost_per: {
    eventName: COST,
    label: 'cost per',
  },
  revenue_per: {
    eventName: REVENUE,
    label: 'revenue per',
  },
  roas_per: { eventName: ROAS, label: 'roas per' },
  rate_for: {
    eventName: EVENT_DATA_FIELD_KEYS.INSTALL,
    label: 'rate',
  },
};

export const generateDynamicCalculationKey = (
  calculationId: DynamicCalculationId,
  eventName: string
): DynamicCalculationDataFieldKey => {
  return `${DYNAMIC_CALCULATION_DATA_FIELD_KEY_PREFIX}${calculationId}${DATA_FIELD_KEY_SEPARATOR}${eventName}`;
};

export const isCalculationIdSupportedForDynamicCalculation = (
  calculationId: string
): calculationId is DynamicCalculationId => {
  return !!CALCULATION_ID_EVENTS[calculationId];
};

export const getDynamicCalculationId = (key: string): DynamicCalculationId | undefined => {
  const [, calculationId] = key.split(DATA_FIELD_KEY_SEPARATOR);
  if (isCalculationIdSupportedForDynamicCalculation(calculationId)) {
    return calculationId;
  }
};

export const CUSTOM_METRICS_EVENT_NAME = 'Custom Metrics';
export const COST_PER: DynamicCalculationId = 'cost_per';
export const RATE_FOR: DynamicCalculationId = 'rate_for';
export const REVENUE_PER: DynamicCalculationId = 'revenue_per';
